import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { baseUrl } from '../../../config'
import Header from '../../commons/Header'
import Footer from '../../commons/footer/Footer'
import PageLayout from '../../commons/PageLayout'
import SEO from '../../commons/SEO'
import styled from 'styled-components'
import ArticleCard from './ArticleCard'
import {IArticle} from '../../../types'
import qs from 'query-string'

const seoTitle = 'Articoli | QuintoPuoi'
const seoDescription = 'Tutti gli articoli e gli approfondimenti su cessione del quinto, anticipo TFS e prestiti personali.'

const Articles = () => {
  const [articles, setArticles] = useState<any>([])
  const getAllArticles = () => {
    const filters = {
      and: 'published=true',
      order: 'DESC',
      order_field: 'publicationDate'
    }
    const filtersStringify = qs.stringify(filters)
    const getEndpoint = `${baseUrl}/articles?${filtersStringify}`

    axios
      .get(getEndpoint)
      .then(({ data }) => {
        setArticles(data.payload?.filter((article: any) => article.category?.id !== 3))
      })
      .catch((err) => {
        console.error(err)
      })
  }

  useEffect(() => {
    getAllArticles()
  }, [])

  return (
    <>
      <SEO title={seoTitle} description={seoDescription}/>
      <Header></Header>
      {/* PageLayout porta il <main id={MAIN_ID}>: senza, lo skip link
          "Salta al contenuto principale" puntava a un id inesistente (WCAG 2.4.1).
          Nessun `title`: il titolo visibile della pagina e' gia' qui sotto e sale
          a <h1> (vedi il commento sulla prop `title` di PageLayout). */}
      <PageLayout>
        <Container>
          <SectionTitle as="h1">Articoli</SectionTitle>
          <Section>
            {articles &&
              articles.map((a: IArticle, idx: number) => (
                <ArticleCard article={a} key={idx}/>
              ))}
          </Section>
        </Container>
      </PageLayout>
      <Footer></Footer>
    </>
  )
}

export default Articles

const Container = styled.div`
  max-width: 1140px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 150px;
`
const SectionTitle = styled.h2`
  margin: 2rem 0;
`
const Section = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`
